import React from 'react'
import { InputGroup, InputGroupAddon } from 'reactstrap'
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import DatePicker from 'react-datepicker'

const TemplateDatepicker = ({
  selectedDate,
  onChange
}) => {
  return (
    <>
      <InputGroup>
        <InputGroupAddon addonType="prepend">
          <div className="input-group-text">
            <FontAwesomeIcon icon={faCalendarAlt}/>
          </div>
        </InputGroupAddon>
        <DatePicker
          className="form-control"
          selected={ selectedDate }
          onChange={ onChange }
        />
      </InputGroup>
    </>
  )
}

export default TemplateDatepicker